import React from 'react';
import styled from 'styled-components';

const Label = styled.label`
  font-size: 14px;
  margin-right: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  user-select: none;
`;

const Input = styled.input`
  margin-right: 4px;
`;

export default ({ label = '', ...props }) => (
  <Label>
    <Input type="checkbox" {...props} />
    {label}
  </Label>
);
